var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Installation-process"},_vm._l((_vm.activateImgSrc),function(i){return _c('div',{key:i.vulae,staticClass:"activate-home"},[_c('img',{staticClass:"step-img",attrs:{"src":i.stepImgUrl,"alt":""},on:{"click":function($event){return _vm.order(i)}}}),_c('img',{staticClass:"activate-img",attrs:{"src":i.imgUrl,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }